import { Suspense, lazy } from "react";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import { ScrollToTop } from "@/components/ScrollToTop";
import { SectionSkeleton } from "@/components/LazySection";

// Lazy load below-the-fold sections for better initial load performance
const ForWhoSection = lazy(() => import("@/components/ForWhoSection/index"));
const FeaturesSection = lazy(() => import("@/components/FeaturesSection"));
const HowItWorksSection = lazy(() => import("@/components/HowItWorksSection"));
const BenefitsSection = lazy(() => import("@/components/BenefitsSection"));
const PricingSection = lazy(() => import("@/components/PricingSection"));
const ContactSection = lazy(() => import("@/components/ContactSection"));
const DisclaimerSection = lazy(() => import("@/components/DisclaimerSection"));
const FAQSection = lazy(() => import("@/components/FAQSection"));
const Footer = lazy(() => import("@/components/Footer"));
const Chatbot = lazy(() => import("@/components/Chatbot"));

const Index = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero loads immediately - critical for LCP */}
        <HeroSection />
        
        {/* Below-the-fold sections load lazily */}
        <Suspense fallback={<SectionSkeleton height="600px" />}>
          <ForWhoSection />
        </Suspense>
        
        <Suspense fallback={<SectionSkeleton height="500px" />}>
          <FeaturesSection />
        </Suspense>
        
        <Suspense fallback={<SectionSkeleton height="450px" />}>
          <HowItWorksSection />
        </Suspense>
        
        <Suspense fallback={<SectionSkeleton height="400px" />}>
          <BenefitsSection />
        </Suspense>
        
        <Suspense fallback={<SectionSkeleton height="500px" />}>
          <PricingSection />
        </Suspense>
        
        <Suspense fallback={<SectionSkeleton height="500px" />}>
          <ContactSection />
        </Suspense>
        
        <Suspense fallback={<SectionSkeleton height="100px" />}>
          <DisclaimerSection />
        </Suspense>
        
        <Suspense fallback={<SectionSkeleton height="400px" />}>
          <FAQSection />
        </Suspense>
      </main>
      
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
      
      <ScrollToTop />
      
      <Suspense fallback={null}>
        <Chatbot />
      </Suspense>
    </div>
  );
};

export default Index;
